import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { sortArray } from '../../Utility/PropertyListUtility'
import PropertyUnitMix from '../../PropertyUnitMix/PropertyUnitMix'
import { Apartment } from '@material-ui/icons'
import { formatDate } from '../../../PropertySearch/Utility/Utility'

const useStyles = makeStyles({
    propPicture: {
        height: '144px !important',
        maxWidth: '200px !important',
        position: 'relative'
    },
    width: {
        maxWidth: '200px !important',
        position: 'relative'
    }
})

const PropertyDetails = props => {

    const classes = useStyles()
    const { row, compType, isStudentHousingProperty } = props
    const { data } = row
    const property = data.omniviewproperty[0]

    const [omniviewtransactionhistory, setOmniviewtransactionhistory] = useState([])

    useEffect(() => {
        let ovtransactionhistory = []
        if (data && data.omniviewtransactionhistory) {
            ovtransactionhistory = data.omniviewtransactionhistory.filter(x => x.transactionType && x.transactionType.toLowerCase() === 'sale')
            ovtransactionhistory = [...sortArray(ovtransactionhistory, 'saleDate', 'desc')]
            setOmniviewtransactionhistory(ovtransactionhistory)
        }
    }, [row])


    property.propPicture = property.propPicture ? property.propPicture : ''
    // const compType = 'rent'

    const getSalesFieldValue = fieldName => {

        let returnVal = '-'

        if (omniviewtransactionhistory.length && omniviewtransactionhistory[0][fieldName]) {
            returnVal = omniviewtransactionhistory[0][fieldName]
        }

        return returnVal
    }

    const getPropertyFieldValue = fieldName => {

        let returnVal = '-'

        try {
            if (property && property[fieldName]) {
                returnVal = property[fieldName]
                if (fieldName === 'occupancy' && returnVal && returnVal !== '-') {

                    returnVal = `${returnVal}%`
                    if (property['occupancyAsOfDate']) {
                        var options = { year: 'numeric', month: 'short', day: 'numeric' }
                        let occupancyAsOfDate = new Intl.DateTimeFormat('en-US', options).format(new Date(property['occupancyAsOfDate']))

                        returnVal += ` as of ${occupancyAsOfDate}`
                    }
                }

                if (fieldName === 'preleasing' && returnVal && returnVal !== '-') {
                    returnVal = `${returnVal}%`
                    if (property['preleasingAsOfDate']) {
                        var options = { year: 'numeric', month: 'short', day: 'numeric' }
                        let preleasingAsOfDate = new Intl.DateTimeFormat('en-US', options).format(new Date(property['preleasingAsOfDate']))

                        returnVal += ` as of ${preleasingAsOfDate}`
                        // returnVal += ` as of ${property['preleasingAsOfDate']}`
                    }
                }
                if (fieldName === 'distanceToCampus') {
                  returnVal = returnVal ? `${returnVal} miles` : '-'
                }

                // if (fieldName === 'sourceLastModifiedDate') {
                //         returnVal = formatDate(returnVal)
                // }
            }
        } catch (error) {
            console.log('error in getPropertyFieldValue:::', error)
        }

        return returnVal
    }

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-12 pb-4 px-5 border-b-5 border-color-gray-10">
                <div className="overflow-hidden md:col-span-2 py-4">
                    <div className="grid grid-cols-2 md:grid-cols-1 w-screen-75 md:w-full">
                        <div className="w-full col-span-1 md:col-span-2">
                            <div className="flex flex-row h-full w-full">
                                <div className={`mb-4 w-full ${classes.propPicture}`}>
                                    {property.propPicture ?
                                        <img src={property.propPicture} style={{ 'position': 'absolute', 'top': '0', 'left': '0', 'width': '100%', 'height': '100%' }} />
                                        : <div className="w-full h-full bg-gray-10">
                                            <span className="absolute" style={{ 'top': 'calc(50% - 24px/2)', 'left': 'calc(50% - 24px/2)' }}>
                                                <Apartment color="disabled" fontSize="large" />
                                            </span>
                                        </div>}
                                </div>
                            </div>
                        </div>
                        <div className={`flex flex-col px-4 md:px-0 text-1 md:border-0 md:border-t-1 md:border-base ${classes.width}`}>
                            <div className="py-2">
                                <span className="text-1 text-muted">Type: </span>{property.omniViewPropertyType}
                            </div>
                            <div className="py-2">
                                <span className="text-1 text-muted">Subtype: </span>{property.subType}
                            </div>
                            <div className="py-2">
                                <span className="text-1 text-muted">Last Updated: </span>{getPropertyFieldValue('sourceLastModifiedDate')}
                            </div>
                            <div className="py-2">
                                <span className="text-1 text-muted">Occupancy: </span>
                                <span>{getPropertyFieldValue('occupancy')}</span>
                            </div>
                            <div className="py-2">
                                <span className="text-1 text-muted">Pre-Leased Occupancy: </span>{getPropertyFieldValue('preleasing')}
                            </div>
                            <div className="py-2">
                                <span className="text-1 text-muted">BCM Source Type: </span>{getPropertyFieldValue('sourceType')}
                            </div>
                            <div className="py-2">
                                <span className="text-1 text-muted">BCM Source Note: </span>{getPropertyFieldValue('sourceNote')}
                            </div>
                            <div className="py-2">
                                <span className="text-1 text-muted">Metering: </span>{getPropertyFieldValue('metering')}
                            </div>

                            {compType === 'sales' ?
                                <>
                                    <div className="py-2">
                                        <span className="text-1 text-muted">Seller: </span>
                                        {getSalesFieldValue('sfSellerAccountId') !== "-" ? <a href={`${window.REACT_GLOBAL_CONFIG.SF_URL}${getSalesFieldValue('sfSellerAccountId')}`} target="_blank" rel="noopener noreferrer">{getSalesFieldValue('sfSellerAccountName')}</a> :
                                            getSalesFieldValue('sellerGoldenName')}
                                    </div>
                                    <div className="py-2">
                                        <span className="text-1 text-muted">Buyer: </span>
                                        {getSalesFieldValue('sfBuyerAccountId') !== "-" ? <a href={`${window.REACT_GLOBAL_CONFIG.SF_URL}${getSalesFieldValue('sfBuyerAccountId')}`} target="_blank" rel="noopener noreferrer">{getSalesFieldValue('sfBuyerAccountName')}</a> :
                                            getSalesFieldValue('buyerGoldenName')}
                                    </div>
                                </>
                              : null}
                            {isStudentHousingProperty ?
                                <>
                                  <div className="py-2">
                                      <span className="text-1 text-muted">Distance to Campus: </span>{getPropertyFieldValue('distanceToCampus')}
                                  </div>
                                  <div className="py-2">
                                      <span className="text-1 text-muted">University: </span>{getPropertyFieldValue('university')}
                                  </div>
                                </>
                            : null}

                        </div>
                    </div>
                </div>
                <div className="overflow-hidden md:col-span-10">
                    <PropertyUnitMix row={row} source={props.source} setSourceFromListTable={props.setSource}></PropertyUnitMix>
                </div>
            </div>

            {/* <div className="grid grid-cols-1 md:grid-cols-7 pb-4 border-b-1 border-base hidden">
                <div style={{ 'min-height': '144px' }} className="overflow-hidden md:col-span-3">
                    <div className="flex flex-row h-full">
                        <div style={{ 'min-width': '200px', 'max-width': '200px', 'height': '144px', 'position': 'relative' }}>
                            <img src={property.propPicture} style={{ 'position': 'absolute', 'top': '0', 'left': '0', 'width': '100%' }} />
                        </div>
                        <div className="flex flex-col justify-between px-5" >
                            <div className="flex flex-col">
                                <span className="font-semibold">{property.propertyName}</span>
                                <span>{getAddress()}</span>
                            </div>
                            <div className="flex flex-wrap">
                                {isSubjectProperty ?
                                    <span className="badge rounded-pill bg-white border-1 border-base px-4 py-3 mr-3 mt-3">Subject Property</span>
                                    : null}
                                <span className="badge rounded-pill bg-white border-1 border-base px-4 py-3 mr-3 mt-3">{property.omniViewPropertyType}</span>
                                <span className="badge rounded-pill bg-white border-1 border-base px-4 py-3 mt-3">{property.subType}</span>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="overflow-hidden bg-gray-5 p-4 md:col-span-2 ">
                    <div className="flex flex-col justify-between h-full">
                        <div className="flex flex-row justify-between">
                            <span className="">Total Units:</span>
                            <span className="font-semibold">{getFormattedNumber(property.propertyTotalUnits)}</span>
                        </div>
                        <div className="flex flex-row justify-between">
                            <span className="">Year Built | Reno:</span>
                            <span className="font-semibold">{`${property.yearBuilt} | ${property.yearRenovated}`}</span>
                        </div>
                        <div className="flex flex-row justify-between">
                            <span className="">Occupancy:</span>
                            <span className="font-semibold">{getFormattedNumber(property.occupancy, '%')}</span>
                        </div>
                        <div className="flex flex-row justify-between">
                            <span className="">RSF:</span>
                            <span className="font-semibold">{getFormattedNumber(property.rentableSquareFeet)}</span>
                        </div>
                    </div>
                </div>
                {compType === 'sales' ?
                    <div className="overflow-hidden bg-gray-5 p-4 md:col-span-2 border-l-1 border-base">
                        <div className="flex flex-col justify-between h-full">
                            <div className="flex flex-row justify-between">
                                <span className="">Price:</span>
                                <span className="font-semibold">{getFormattedNumber(getSalesFieldValue('salePrice'), '$')}</span>
                            </div>
                            <div className="flex flex-row justify-between">
                                <span className="">$/Unit:</span>
                                <span className="font-semibold">{getFormattedNumber(divideNumbers(getSalesFieldValue('salePrice'), getSalesFieldValue('numberUnits')), '$')}</span>
                            </div>
                            <div className="flex flex-row justify-between">
                                <span className="">$/Sq. Ft:</span>
                                <span className="font-semibold">{getFormattedNumber(getSalesFieldValue('pricePerSf'), '$', '2', '2')}</span>
                            </div>
                            <div className="flex flex-row justify-between">
                                <span className="">CAP Rate:</span>
                                <span className="font-semibold">{getFormattedNumber(getSalesFieldValue('capRate'), '%')}</span>
                            </div>
                            <div className="flex flex-row justify-between">
                                <span className="">GRM:</span>
                                <span className="font-semibold">{getFormattedNumber(getSalesFieldValue('grossRentMultiplier'), '', '2', '2')}</span>
                            </div>
                        </div>
                    </div>
                    : null}
                {compType === 'rent' ?
                    <div className="overflow-hidden bg-gray-5 p-4 md:col-span-1 hidden">
                        <div className="flex flex-col justify-between h-full ">
                            <div className="flex flex-row justify-between">
                                <span>RSF:</span>
                                <span className="font-semibold">{property.rentableSquareFeet}</span>
                            </div>
                            <div className="flex flex-row justify-between">
                                <span>Avg Sq. Ft:</span>
                                <span className="font-semibold">{property.yearBuilt}</span>
                            </div>
                            <div className="flex flex-row justify-between">
                                <span>Avg Rent/Sq. Ft:</span>
                                <span className="font-semibold">{property.averageRentPerSquareFeet}</span>
                            </div>
                            <div className="flex flex-row justify-between">
                                <span>Avg Mkt Rent:</span>
                                <span className="font-semibold">{property.metering}</span>
                            </div>
                        </div>
                    </div>
                    : null}

            </div> */}
        </>
    )

}

export default PropertyDetails

PropertyDetails.propTypes = {
    row: PropTypes.any,
    compType: PropTypes.any
}
